import { CoreMenuModel } from '../../../../core/models';

export class MenuModel extends CoreMenuModel {
	defaults() {
		return {
			menu_for_authorized_users: {
				teams: {
					path: '/fantasy/team',
					name: 'My Team',
					sub_menus_list: [
						{
							method_name: 'team',
							path: '/fantasy/team',
							name: 'My Team'
						},
						{
							method_name: 'trades',
							path: '/fantasy/trades',
							name: 'Trades'
						},
						{
							method_name: 'rankings',
							path: '/fantasy/team/rankings',
							name: 'Rankings'
						}
					]
				},
				leagues: {
					path: '/fantasy/leagues',
					name: 'Leagues',
					sub_menus_list: [
						{
							method_name: 'leagues',
							path: '/fantasy/leagues',
							name: 'My Leagues'
						},
						{
							method_name: 'leagueJoin',
							path: '/fantasy/league/join',
							name: 'Join a League',
							check_for_end_season: true,
							message: 'Leagues cannot be joined after Round 25 has begun'
						},
						{
							method_name: 'leagueCreate',
							path: '/fantasy/league/create',
							name: 'Create a League',
							check_for_end_season: true,
							message: 'Leagues cannot be created after Round 25 has begun'
						}
					],
					extra_menus_list: [
						{
							method_name: 'leagueLadder',
							path: '/fantasy/league/:id/ladder',
							name: 'Ladder',
						},
						{
							method_name: 'leagueFixtures',
							path: '/fantasy/league/:id/fixtures',
							name: 'Fixtures',
							only_head_to_head: true,
							extra_method: 'matchUp'
						},
						{
							method_name: 'leagueSettings',
							path: '/fantasy/league/:id/manage',
							name: 'Settings'
						},
						{
							method_name: 'leagueInvites',
							path: '/fantasy/league/:id/manage/invites',
							name: 'Invites',
							check_by_commissioner: true,
							check_by_supported_team: true
						}
					],
					breadcrumb: {
						path: '/fantasy/leagues',
						name: 'My Leagues'
					}
				},
				stats: {
					path: '/stats-centre',
					name: 'Stats Centre',
					sub_menus_list: [
						{
							method_name: 'statsCentre',
							path: '/stats-centre',
							name: 'Stats Centre'
						},
						{
							method_name: 'playerProfile',
							path: '/player-profile',
							name: 'Player Profiles'
						},
						{
							method_name: 'playerComparison',
							path: '/compare',
							name: 'Player Comparison'
						}
					]
				},
				match_centre: {
					path: '/match-centre',
					name: 'Match Centre',
					sub_menus_list: [
						{
							method_name: 'matchCentre',
							path: '/match-centre',
							name: 'Match Centre'
						}
					]
				},
				helps: {
					path: '/help/notice-board',
					name: 'Help',
					sub_menus_list: [
						{
							method_name: 'whatsNew',
							path: '/help/notice-board',
							name: 'Notice Board'
						},
						{
							method_name: 'guidelines',
							path: '/help/guidelines',
							name: 'Classic Guidelines'
						},
						{
							method_name: 'fantasyCoach',
							path: '/help/coach',
							name: 'Fantasy Coach'
						},
						{
							method_name: 'draftGuidelines',
							path: '/help/draft/guidelines',
							name: 'Draft Guidelines'
						},
						{
							method_name: 'faq',
							path: '/help/faq',
							name: 'FAQs'
						},
						{
							method_name: 'contactUs',
							path: '/help/contact-us',
							name: 'Contact Us'
						},
						{
							method_name: 'prizes',
							path: '/help/prizes',
							name: 'Prizes'
						},
						{
							method_name: 'termsAndConditions',
							path: '/help/terms-and-conditions',
							name: 'Terms and Conditions'
						}
					]
				},
				account: {
					path: '/account/settings',
					name: 'My Account',
					sub_menus_list: [
						{
							method_name: 'settings',
							path: '/account/settings',
							name: 'Acc Settings'
						},
						{
							method_name: 'communications',
							path: '/account/communications',
							name: 'Communications'
						},
						{
							method_name: 'coachSettings',
							path: '/account/coach-settings',
							name: 'Coach Settings'
						}
					]
				}
			},
			menu_for_not_authorized_users: {
				home: {
					path: '/',
					name: 'Home',
					sub_menus_list: []
				},
				stats: {
					path: '/stats-centre',
					name: 'Stats Centre',
					sub_menus_list: [
						{
							method_name: 'statsCentre',
							path: '/stats-centre',
							name: 'Stats Centre'
						}
					]
				},
				match_centre: {
					path: '/match-centre',
					name: 'Match Centre',
					sub_menus_list: [
						{
							method_name: 'matchCentre',
							path: '/match-centre',
							name: 'Match Centre'
						}
					]
				},
				helps: {
					path: '/help/notice-board',
					name: 'Help',
					sub_menus_list: [
						{
							method_name: 'whatsNew',
							path: '/help/notice-board',
							name: 'Notice Board'
						},
						{
							method_name: 'guidelines',
							path: '/help/guidelines',
							name: 'Classic Guidelines'
						},
						{
							method_name: 'fantasyCoach',
							path: '/help/coach',
							name: 'Fantasy Coach'
						},
						{
							method_name: 'draftGuidelines',
							path: '/help/draft/guidelines',
							name: 'Draft Guidelines'
						},
						{
							method_name: 'faq',
							path: '/help/faq',
							name: 'FAQs'
						},
						{
							method_name: 'contactUs',
							path: '/help/contact-us',
							name: 'Contact Us'
						},
						{
							method_name: 'prizes',
							path: '/help/prizes',
							name: 'Prizes'
						},
						{
							method_name: 'termsAndConditions',
							path: '/help/terms-and-conditions',
							name: 'Terms and Conditions'
						}
					]
				}
			},
			menu_for_off_season: {
				home: {
					path: '/off-season-2021',
					name: 'Home',
					sub_menus_list: []
				},
				// stats: {
				// 	path: '/stats-centre',
				// 	name: 'Stats Centre'
				// },
				match_centre: {
					path: '/match-centre',
					name: 'Match Centre',
					sub_menus_list: [
						{
							method_name: 'matchCentre',
							path: '/match-centre',
							name: 'Match Centre'
						}
					]
				},
				rankings: {
					method_name: 'rankings',
					path: '/rankings',
					name: 'Rankings',
					sub_menus_list: [
						{
							method_name: 'rankings',
							path: '/rankings',
							name: 'Rankings'
						},

						{
							method_name: 'prizes',
							path: '/help/prizes',
							name: 'Prizes'
						},
						{
							method_name: 'matchCentreLanding',
							path: '/match-centre',
							name: 'Match Centre'
						},
						// {
						// 	method_name: 'statsCentre',
						// 	path: '/stats-centre',
						// 	name: 'Stats Centre'
						// },
					]
				},
				prizes: {
					method_name: 'prizes',
					path: '/help/prizes',
					name: 'Prizes'
				},
			},
			external_menu_items: [
				{
					path: '/draft',
					name: 'Draft',
					check_is_authorized: true
				},
				{
					path: 'https://www.nrl.com/news/topic/fantasy/',
					name: 'Fantasy News'
				},
				// {
				// 	path: '/pulse',
				// 	name: 'Pulse'
				// },
				{
					path: process.env.TIPPING_LINK,
					name: 'Tipping'
				},
				{
					path: 'http://www.nrl.com/',
					name: 'NRL Home'
				},
				{
					path: 'https://ladderpredictor.nrl.com?source=fantasy',
					name: 'Ladder Predictor'
				},
			],
			id: 0,
			show_extra_menu: false,
			is_authorized: true,
			menu_items: {},
			current_menu: {}
		};
	}
}

export default MenuModel;